import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function BusinessProfile() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', alignItems: 'top', justifyContent: 'center', py: { xs: 2, md: 6 }, px: { xs: 1, md: 0 } }}>
      <Paper sx={{ p: { xs: 2, md: 4 }, maxWidth: 1100, width: '100%', borderRadius: 6, boxShadow: 0, border: '1px solid', borderColor: 'divider', mx: 'auto', background: 'background.paper' }}>
        <Typography variant="h4" fontWeight={700} color="text.primary" mb={3}>
          Business Profile & Settings
        </Typography>
        <Typography variant="body1">Profile info and settings form will app/Appear here.</Typography>
      </Paper>
    </Box>
  );
} 
